import { gql } from 'graphql-request'

export namespace HomeQualityCheckInspectionTaskMutations {
  export function updateHomeQualityCheckInspectionTasks() {
    return gql`
      mutation updateHomeQualityCheckInspectionTasks(
        $homeId: Int
        $homeQualityCheckInspectionTasks: [HomeQualityCheckInspectionTaskUpdate]
      ) {
        updateHomeQualityCheckInspectionTasks(
          homeId: $homeId
          homeQualityCheckInspectionTasks: $homeQualityCheckInspectionTasks
        )
      }
    `
  }
}
